import React from "react"
import { useLocation } from "@reach/router"
import { useSiteMetadata } from "../hooks/use-site-metadata"

export default function Seo({ title, description, imageUrl, children }) {
  const { title: defaultTitle, description: defaultDescription, siteUrl } = useSiteMetadata()
  const metaTitle = title || defaultTitle
  const metaDescription = description || defaultDescription
  const metaUrl = siteUrl + useLocation().pathname

  return (
    <>
      <html lang="fr" />
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      {imageUrl && <meta name="image" content={imageUrl} />}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaUrl} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {children}
    </>
  )
}
